import groove from 'api/groove'
import { BEGIN, COMMIT, REVERT } from 'redux-optimist'
import { v4 as uuidV4 } from 'uuid'
import { oauthTokenSelector } from 'selectors/app'
import { doGraphqlRequest, doApiReadRequest } from 'ducks/requests'
import {
  UPDATE_CURRENT_USER,
  UPDATE_USER_PREFERENCES_REQUEST,
  UPDATE_USER_PREFERENCES_SUCCESS,
  UPDATE_USER_PREFERENCES_FAIL,
  RESEND_CONFIRMATION_TOKEN,
} from '../types'
import { updateCurrentUserMutation, confirmCurrentUserMutation } from '../api'

export const doUpdateCurrentUser = fields => {
  return dispatch => {
    return dispatch(
      doGraphqlRequest(
        UPDATE_CURRENT_USER,
        updateCurrentUserMutation,
        { input: { ...fields } },
        { throwOnError: true }
      )
    )
  }
}

export function doUpdateUserPreferences(prefs) {
  return (dispatch, getState) => {
    const state = getState()
    const token = oauthTokenSelector(state)
    const tid = uuidV4()
    const serializedData = JSON.stringify({ agent: prefs })
    dispatch({
      type: UPDATE_USER_PREFERENCES_REQUEST,
      payload: { preferences: prefs },
      optimist: { type: BEGIN, id: tid },
    })
    return groove
      .put(token, `/v1/preferences`, null, serializedData)
      .then(() => {
        dispatch({
          type: UPDATE_USER_PREFERENCES_SUCCESS,
          optimist: { type: COMMIT, id: tid },
        })
      })
      .catch(error => {
        dispatch({
          type: UPDATE_USER_PREFERENCES_FAIL,
          payload: { error },
          optimist: { type: REVERT, id: tid },
        })
      })
  }
}

export const doConfirmCurrentUser = confirmationToken => {
  return dispatch => {
    return dispatch(
      doGraphqlRequest(
        UPDATE_CURRENT_USER,
        confirmCurrentUserMutation,
        { input: { confirmationToken } },
        { throwOnError: true }
      )
    )
  }
}

export const doResendConfirmationToken = () => {
  return dispatch => {
    return dispatch(
      doApiReadRequest(
        RESEND_CONFIRMATION_TOKEN,
        'v1/me/resend_confirmation_token'
      )
    )
  }
}
